export default __webpack_public_path__ + "static/calendar-3-2a9f508cbfb9ee52f54518c13af0b8ac.svg";